import React, {useState} from "react";
import styled from 'styled-components';
import HamburgerMenu from "./hamburgerMenu";
import Nav from "./nav";


const StyledHeader = styled.header`
  height: 10vh;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5vw;
`;
const StyledLogo = styled.p`
  font-size: 30px;
  font-weight: bold;
  margin: 0;
`;

const StyledNav = styled.nav`
  width: 70vw;
  height: 100vh;
  background-color: #FF007A;
  position: absolute;
  z-index: 99;
  right: 0;
  top: 0;
  grid-template-rows: 1fr 9fr;
  display: ${({isOpen}) => isOpen ? 'grid' : 'none'};
`;

const StyledNavHeader = styled.div`
  display: flex;
  padding: 0 5vw;
  justify-content: space-between;
  align-items: center;
`;

const DesktopNav = styled.nav`
  display: none;
  @media screen and (min-width: 1200px) {
    display: block;
  }
`;


const StyledLink = styled.a`
  text-decoration: none;
  color: #fff;
  border: ${props => props?.border ? '2px solid #fff' : 'none'};
  border-radius: ${props => props.border ? '50px' : 'none'};
  padding: ${props => props.border ? '10px 30px' : '0'};
  margin-right: ${props => props.mr ? '20px' : '0'};

`;


const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <StyledHeader>
      <StyledLogo>Markai</StyledLogo>
      <HamburgerMenu isOpen={isOpen} open={setIsOpen}/>
      <DesktopNav><Nav/></DesktopNav>
      <DesktopNav>
        <StyledLink mr>Login</StyledLink>
        <StyledLink border>Register</StyledLink>
      </DesktopNav>
      <StyledNav isOpen={isOpen}>
        <StyledNavHeader>
          <StyledLink>Login</StyledLink>
          <StyledLink border>Register</StyledLink>
          <HamburgerMenu isOpen={isOpen} open={setIsOpen}/>
        </StyledNavHeader>
        <Nav/>
      </StyledNav>
    </StyledHeader>
  )
};


export default Header;
